import { nullable, object, string } from "superstruct";

const CustomerAddressSchema = object({
    firstName: nullable(string()),
    lastName: nullable(string()),
    address: nullable(string()),
    city: nullable(string()),
    state: nullable(string()),
    country: nullable(string()),
    postalCode: nullable(string()),
});

export default CustomerAddressSchema;
